import React from "react";
import Home from './Pages/Home';
import Matches from './Pages/Matches';
import { Switch, Route } from "react-router";
import Navbar from "./Components/Navbar";
import Teams from "./Pages/Teams";
import Playersind from "./Pages/Playersind";
import Playerspak from "./Pages/Playerspak";
import Playerseng from "./Pages/Playerseng";
import Playersaus from "./Pages/Playersaus";
import Venues from "./Pages/Venue";
import Pointstable from "./Pages/Pointstable";

const App = ()=> {
  return (
    <>
    <Navbar/>
    <Switch>
      <Route exact path="/home" component={Home}/>
      <Route exact path="/matches" component={Matches}/>
      <Route exact path="/teams" component={Teams}/>
      <Route exact path="/playersIndia" component={Playersind}/>
      <Route exact path="/playersPakistan" component={Playerspak}/>
      <Route exact path="/playersEngland" component={Playerseng}/>
      <Route exact path="/playersAustralia" component={Playersaus}/>
      <Route exact path="/venues" component={Venues}/>
      <Route exact path="/points" component={Pointstable}/>
      <Route component={Home}/>
    </Switch>
    </>
  );
}

export default App;
